function isUpdaterFunction(updater) {
  return typeof updater === "function";
}
export {
  isUpdaterFunction
};
//# sourceMappingURL=types.js.map
